import { useState, useEffect, useMemo, useRef } from 'react';

import api from '../../apis';
import moment from 'moment';
import ReactTable from '../general/form-control/react-table';
import { useFilter } from '../../context/FilterContext';
import { usePagination } from './helper';

import { numberWithCommas } from '../general/convertor';
import PortfolioUnrealizedHistoryModal from '../modals/PortfolioUnrealizedHistoryModal';
import { getStock } from '../../apis/feedProvider';

import UpArrowIcn from '../asset/icon/os_update_green.png';
import DownArrowIcn from '../asset/icon/os_update_red.png';
import { getUserDetail,useLocalStorageListener } from '../../hooks/handleUserLocalStorage';


let triggerAPITimer = null;
let triggerUpdateStockAPITimer = null;
let timerMillisec = 5000;

const PortfolioUnrealizedTbl = ({
    orderNo
}:any) => {
    const [accounts, setAccounts] = useState([]);
    const { filterParams } = useFilter();

    const [_inputs, _setInputs] = useState({});
    const [tableData, setTableData] = useState([]);
    const tableDataRef = useRef(tableData); // Ref to store the latest tableData


    const [loading, setLoading] = useState(false);
    const { tablePagination, setTablePagination } = usePagination();
    const [cStockIndexs, setCStockIndexs ] = useState([]);

    const [prevData, setPrevData] = useState([]);
    const [highlightedCells, setHighlightedCells] = useState({});

    const [currencyGroupData,setCurrencyGroupData] = useState({});


    const currentPageRef = useRef(1);
    const currentPageSizeRef = useRef(10);


    // const [cookies, setCookie, removeCookie] = useCookies(['user']);
   // const [userName, setUserName] = useState('');
    const userNameRef = useRef('');

    useEffect(() => {
      //check if logined
    //   if (cookies.user) {
    //     if (cookies.user.user) {
    //         let userDetail = cookies.user.user;
         
    //         userNameRef.current = userDetail.username;
    //     }
    // }
        return () => {
           pauseTimer();
        };
    }, []);


    useLocalStorageListener((newUserValue) => {
        let localUser = getUserDetail();
        if(!localUser) return;
        if(localUser.user){   
            let userDetail = localUser.user;
            userNameRef.current = userDetail.username;
        }
    });



     // Set up interval to perform action every 5 seconds based on latest `tableData`
    // useEffect(() => {

    //     const intervalId = setInterval(()=>updateLatestStockPrice(), 5000);
    //     // Cleanup the interval on component unmount
    //     return () => clearInterval(intervalId);
    // }, []);

    useEffect(() => {
       // console.log("filterParams",filterParams)
        handleFilter(filterParams)
       
    }, [filterParams]);

    useEffect(() => {
        if(tablePagination){
            currentPageRef.current = tablePagination.currentPage
        }
        
    }, [tablePagination]);


    const handleFilter = (filterParams:any)=>{
        if(Object.keys(filterParams).length == 0) return;

        console.log("filterParams",filterParams)


        let accounts = filterParams["accounts[]"] ||[];
        requestTableData(accounts,currentPageRef.current,filterParams);
        _setInputs(filterParams);
        setAccounts(accounts);
    }

    const requestTableData = async (accounts:string[],cPage=1,inputs:any={},haveLoading=true,cPageSize = null) =>{
       // console.log("requestTableData cPage",cPage)
        pauseTimer();   
        // if(accounts.length <1) {
        //     setTableData([])
        //     return 
        // }

        if(haveLoading){
            setTableData([]);
            setLoading(true)
        }


        let requestInputs = inputs;


   
        //add page size
        inputs.size = currentPageSizeRef.current;

        //console.log("getPortfolioUnrealized inputs",inputs)
        let result = await api.getPortfolioUnrealized(accounts[0], inputs,cPage);
//   console.log("getPortfolioUnRealized result ",result)
        if(result.portfolio){
            let data = getFullTableData(result.portfolio);
       
            let latestStockInfos = await updateLatestStockPrice(data);
    
            let finalTableData:any = syncTableData(data,latestStockInfos);
          //  console.log("_finalTableData",finalTableData)

            setTableData(finalTableData)
            tableDataRef.current = finalTableData; // Update the ref with latest data

            let currencyGroupData = groupedByCurrency(finalTableData);
            //console.log("currencyGroupData",currencyGroupData)

            setCurrencyGroupData(currencyGroupData)


           // updateFooterRecord(finalTableData);

           // updateLatestStockPrice(result.portfolio);
        }


        
        if (result.total) {
            setTablePagination({
                currentPage: cPage,
                totalRecords: result.total
            });
        }

       setLoading(false)


       //pull latest based on timer
       triggerAPITimer = setTimeout(() => {
            let currentPage = currentPageRef.current;
            requestTableData(accounts, currentPage ,requestInputs,false);
       }, timerMillisec);

  

  
        // console.log("getTradeHistoryLogs",result)
    }

    const updateLatestStockPrice = async(tableData:any) => {
        const clonedTableData = JSON.parse(JSON.stringify(tableData));
        // const clonedTableData = JSON.parse(JSON.stringify(tableDataRef.current));
        // console.log("clonedTableData",clonedTableData)

        // console.log("start update latest stock price",clonedTableData)
        setCStockIndexs([]);
        let _tableData = clonedTableData;
        let arr:any = [];
        _tableData.forEach((row: any) => {
            //get tid
            let _tid = row.tid;
            if (_tid) {
                arr.push(_tid);
            }
        });

        setCStockIndexs(arr);

        //alert("here")
        const latestStockInfos = await getStock(
            arr,
            userNameRef.current
        );

        return latestStockInfos;
    }

    const getFullTableData = (data:any) => {
        //calculate cost 

        data.forEach((row:any) => {
            row.cost = Number(row.qty) * Number(row.avg_price);
        })

        return data
    }

    const calculateFooterCurrencyData = (data:any) => {
        let totalQuantity = 0;
        let totalCost = 0;
        let totalCostMYR = 0;
        let totalAveragePrice = 0;
        let totalMarketPrice = 0
        let totalMarketValue = 0;
        let totalMarketValueMYR = 0;
        let totalPnl = 0;
        let totalPnlPerc = 0;


        data.forEach((row: any) => {
            const qty = Number(row.qty);
            const avgPrice = Number(row.avg_price);
            const mktPrice = Number(row.mkt_price);
            const mktValue = Number(row.mkt_value);
            const fltPnl = Number(row.flt_pnl);
            const cost = Number(row.cost);
        
            // Check if qty and avgPrice are valid numbers
            if (!Number.isNaN(qty) && qty > 0) {
                totalQuantity += qty;
            }

            if (!Number.isNaN(cost)) {
                totalCost += cost;
            }

            if (!Number.isNaN(row.cost_myr)) {
                totalCostMYR += Number(row.cost_myr);
            }
        
            if (!Number.isNaN(avgPrice) ) {
                totalAveragePrice += avgPrice; 
            }
        
            if (!Number.isNaN(mktPrice)) {
                totalMarketPrice += mktPrice; 
            }
        
            if (!Number.isNaN(mktValue) ) {
                totalMarketValue += mktValue; 
            }
        
            if(!Number.isNaN(row.mkt_value_myr) ){
                totalMarketValueMYR += Number(row.mkt_value_myr); 
            }
            if(!Number.isNaN(fltPnl) ){
                totalPnl += fltPnl; 
            }
         
        });

        
        //Total of UR-Profit & Loss  / Total Cost * 100%
        totalPnlPerc = totalPnl / totalCost * 100; 
        
        // setTotalQuantity(totalQuantity);
        // setTotalCost(totalCost);
        // setTotalCostMYR(totalCostMYR);
        // setTotalAvgPrice(totalAveragePrice);
        // setTotalMarketPrice(totalMarketPrice);
        // setTotalMarketValue(totalMarketValue);
        // setTotalMarketValueMYR(totalMarketValueMYR);
        // setTotalPnl(totalPnl);
        // setTotalPnlPerc(totalPnlPerc);
      
        return {
            totalQuantity,
            totalCost,
            totalCostMYR,
            totalAveragePrice,
            totalMarketPrice,
            totalMarketValue,
            totalMarketValueMYR,
            totalPnl,
            totalPnlPerc,
        }
        
    }

    const pauseTimer = () => {
        clearTimeout(triggerAPITimer);
        clearTimeout(triggerUpdateStockAPITimer);
    }



    const tblColumns = [
        {
            Header:"Account No",
            accessor: 'a_acctno',
            Cell: (v: any) => {
                if (v.value)
                    return (
                        <div className="text-left">
                            {v.value}
                        </div>
                    );
            }
        },
        {
            Header:'Name',
            accessor: 't_name',
            Cell: (data: any) => {
                if(!data.value) return;
                let row = data.row.original;
                return <>
                    <div className="text-left">
                        <div onClick={() => {pauseTimer()}}>
                            <PortfolioUnrealizedHistoryModal data={row} onModalClose={()=>requestTableData(accounts,currentPageRef.current,_inputs,false)}>
                                {data.value}
                            </PortfolioUnrealizedHistoryModal>
                        </div>
                    </div>
                </>;
            },
        },
        {
            Header:'Code',
            accessor: 't_code',
            Cell: (v: any) => {
                if (v.value)
                    return (
                        <div className="text-left">
                            {v.value}
                        </div>
                    );
            }
        },
        {
            Header:'Exchange',
            accessor: 'e_name',
            Cell: (v: any) => {
                if (v.value)
                    return (
                        <div className="text-left">
                            {v.value}
                        </div>
                    );
            }
        },
        {
            Header:'Quantity',
            accessor: 'qty',
            Cell: (v: any) => {
                if (v.value)
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value)}
                        </div>
                    );
            }
        },
        {
            Header:'Currency',
            accessor: 'c_code'
        },
        {
            Header:'Cost',
            accessor: 'cost',

            Cell: ({ row, value }) => {

                const cellKey = `${row.index}-cost`;
               // const isHighlighted = true;
                const isChanged = highlightedCells[cellKey];


                const changeLabel = isChanged ? `(${isChanged})` : '';

                

                if (value)
                    return (
                        <div className={isChanged ? 'highlight' : ''}>
                            <div className="text-right">
                                {/* {changeLabel} asd */}
                               {changeLabel ?"("+numberWithCommas(isChanged,3)+")":""} {numberWithCommas(value,3)}
                            </div>
                        </div>
                    );
            }
        },
        {
            Header:'Cost (MYR)',
            accessor: 'cost_myr',
            
            Cell: ({ row, value }) => {
               // let original = row.original

                if (value)
                    return (
                        <div >
                            <div className="text-right">
                                {/* {original.c_buyrate}
                                {original.c_code} */}
                                {numberWithCommas(value,3)}
                            </div>
                        </div>
                    );
            }
            
        },
        {
            Header:'Avg. Price',
            accessor: 'avg_price',
            Cell: (v: any) => {
                if (v.value)
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value,3)}
                        </div>
                    );
            }
        },
        {
            Header:'Changed',
            accessor: 'changed',
            Cell: ({ row, value }) => {

                const cellKey = `${row.index}-changed`;
                const isChanged = highlightedCells[cellKey] || 0;
                let fontColor ="black";
                if(isChanged != 0){
                    fontColor = value > 0 ? 'green' : 'red';
                }

                if (value)
                    return (
                        <div >
                            <div className="text-right" style={{color:fontColor}}>
                              {numberWithCommas(value,3)}
                            </div>
                        </div>
                    );
            }
        },
        {
            Header:'Mkt. Price',
            accessor: 'mkt_price',
            width: 200, 
            Cell: ({ row, value }) => {

                const cellKey = `${row.index}-mkt_price`;
               // const isHighlighted = true;
    
                const isChanged = highlightedCells[cellKey];
                const changeLabel = getValueChangeIconLabel(isChanged);

                if (value)
                    return (
                        <div className={isChanged ? 'highlight' : ''}>
                            <div className="text-right">
                               {changeLabel} {numberWithCommas(value,3)}
                            </div>
                        </div>
                    );
            }
        },
        
        {
            Header:'Mkt. Value',
            accessor: 'mkt_value',
            width: 200, 
            Cell: ({ row, value }) => {

                const cellKey = `${row.index}-mkt_value`;
                const isChanged = highlightedCells[cellKey];
                const changeLabel = getValueChangeIconLabel(isChanged);

                if (value)
                    return (
                        <div className={isChanged ? 'highlight' : ''}>
                            <div className="text-right">
                               {changeLabel} {numberWithCommas(value,3)}
                            </div>
                        </div>
                    );
            }
        },
        {
            Header:'Mkt. Value (MYR)',
            accessor: 'mkt_value_myr',
            Cell: ({ row, value }) => {

                if (value)
                    return (
                        <div >
                            <div className="text-right">
                               {numberWithCommas(value,3)}
                            </div>
                        </div>
                    );
            }
        },
        {
            Header:'UR-Profit & Loss ',
            accessor: 'flt_pnl',
            Cell: ({ row, value }) => {

                const cellKey = `${row.index}-flt_pnl`;
                const isChanged = highlightedCells[cellKey] || 0;

                let fontColor ="black";
                if(isChanged != 0){
                    fontColor = isChanged > 0 ? 'green' : 'red';
                }

                if (value)
                    return (
                        <div >
                            <div className="text-right" style={{color:fontColor}}>
                              {numberWithCommas(value,3)}
                            </div>
                        </div>
                    );
            }
        },
        {
            Header:'UR-Profit & Loss  % ',
            accessor: 'flt_pnl_perc',
            Cell: ({ row, value }) => {

                const cellKey = `${row.index}-flt_pnl_perc`;
                const isChanged = highlightedCells[cellKey] || 0;
                let fontColor ="black";
                if(isChanged != 0){
                    fontColor = isChanged > 0 ? 'green' : 'red';
                }

                if (value)
                    return (
                        <div >
                            <div className="text-right" style={{color:fontColor}}>
                              {numberWithCommas(value,3)}
                            </div>
                        </div>
                    );
            }
        },
        // {
        //     Header:'FLT PnL',
        //     accessor: 'flt_pnl'
        // },
        // {
        //     Header:'FLT PnL %',
        //     accessor: 'flt_pnl_perc'
        // }
    
    ]

     // Update highlighted cells when data changes
     useEffect(() => {

        //disable highlight on first time render
        if(prevData.length === 0) {
            setPrevData(tableData);
            return;
        }
  
        const newHighlightedCells = {};

        // console.log("tableData123 ",tableData)
        // console.log("prevData123 ",prevData.length)

        tableData.forEach((item, index) => {
            // Check if the price changed
            if (item.mkt_price !== prevData[index]?.mkt_price) {
                const cellKey = `${index}-mkt_price`;
                let change = Number(item.mkt_price) - Number(prevData[index]?.mkt_price)
                newHighlightedCells[cellKey] = change;

                // // Remove highlight after 3 seconds
                // setTimeout(() => {
                //     setHighlightedCells(prev => {
                //         const updated = { ...prev };
                //         delete updated[cellKey];
                //         return updated;
                //     });
                // }, 3000);
            }

            if (item.cost !== prevData[index]?.cost) {
                const cellKey = `${index}-cost`;
                let change = Number(item.cost) - Number(prevData[index]?.cost)
                newHighlightedCells[cellKey] = change;
            }


            if (item.mkt_value !== prevData[index]?.mkt_value) {
                const cellKey = `${index}-mkt_value`;
                let change = Number(item.mkt_value) - Number(prevData[index]?.mkt_value)
                newHighlightedCells[cellKey] = change;
            }

            if (item.flt_pnl !== prevData[index]?.flt_pnl) {
                const cellKey = `${index}-flt_pnl`;
                let change = Number(item.flt_pnl) - Number(prevData[index]?.flt_pnl)
                newHighlightedCells[cellKey] = change;
            }

            if (item.flt_pnl_perc !== prevData[index]?.flt_pnl_perc) {
                const cellKey = `${index}-flt_pnl_perc`;
                let change = Number(item.flt_pnl_perc) - Number(prevData[index]?.flt_pnl_perc)
                newHighlightedCells[cellKey] = change;
            }
            if (item.changed !== prevData[index]?.changed) {
                const cellKey = `${index}-changed`;
                let change = Number(item.changed) - Number(prevData[index]?.changed)
                newHighlightedCells[cellKey] = change;
            }
        });
       // console.log("newHighlightedCells",newHighlightedCells)
        setHighlightedCells(newHighlightedCells);

        let _tableData =[...tableData]
        setPrevData(_tableData);
    }, [tableData]);


    const getValueChangeIconLabel = (value: number) => {
        let icon = null;
        let style = {
            width: '10px',     
        }
        if(value !==0){
            icon = value > 0 ? <img src={UpArrowIcn} alt="" style={style}/> : <img src={DownArrowIcn} alt=""  style={{ ...style, transform: 'rotate(180deg)' }}/>
        }

        let fontColor = value > 0 ? 'green' : 'red';
        const changeLabel = value ? (
            <span style={{
                color: fontColor
            }}>
                ({icon} {numberWithCommas(value, 3)})
            </span>
        ) : null;
        
        return changeLabel;
    }


    const syncTableData = (tableData: any,latestStockInfos:any) => {
        // console.log("tableData",tableData)
       // console.log("latestStockInfos",latestStockInfos)
        let _tableData = JSON.parse(JSON.stringify(tableData));
        let cloneData = [..._tableData];

    
        for (let i = 0; i < cloneData.length; i++) {
            let ccy_rate = cloneData[i].ccy_rate;
            let _tid = cloneData[i].tid;
            let latestStockInfo = latestStockInfos.find(
                (item: any) => item.IdxCode == _tid 
            );  

            if (latestStockInfo) {
            //     console.log("cloneData",cloneData[i])
            //  console.log("latestStockInfo",latestStockInfo);


                let lastPrice = latestStockInfo.LastDone;

                //if not LastDone
                if(!lastPrice){
                    lastPrice = latestStockInfo.LACP;
                }
                //if not LACP
                if(!lastPrice){
                    lastPrice = latestStockInfo.Reference;
                }
                //if not Reference
                if(!lastPrice){
                    lastPrice = latestStockInfo.ClosePrice;
                }
            
                let lastDone = lastPrice/1000;
                cloneData[i].mkt_price = lastDone;
                cloneData[i].mkt_value = Number(cloneData[i].qty) * Number(lastDone);
            }
      
                cloneData[i].cost = Number(cloneData[i].qty) * Number(cloneData[i].avg_price);
                cloneData[i].cost_myr = Number(cloneData[i].cost) * Number(cloneData[i].ccy_rate);
               
                cloneData[i].mkt_value_myr = Number(cloneData[i].mkt_value) * Number(cloneData[i].ccy_rate);
                cloneData[i].flt_pnl = Number(cloneData[i].mkt_value) - Number(cloneData[i].cost);
                cloneData[i].flt_pnl_perc = ((Number(cloneData[i].mkt_price) - Number(cloneData[i].avg_price)) / Number(cloneData[i].avg_price)) * 100;
              
                let changed = cloneData[i].mkt_price - Number(cloneData[i].avg_price);
                const numChanged = Number.isNaN(changed) ? null : changed;

                cloneData[i].changed = numChanged;

                //cloneData[i] = convertToCCYRATE(cloneData[i], ccy_rate);
          
        }

        // console.log("latestStockInfos",latestStockInfos)
       
        // console.log("cloneData",cloneData)

        return cloneData;
      // setTableData(cloneData);
        // _tableData.forEach((row: any) => {

        //     let _tid = row.tid;

        //     if (_tid) {

        //         let latestStockInfo = latestStockInfos.find(
        //             (item: any) => item.IdxCode == _tid
        //         );      

        //       //  console.log("find latestStockInfo",latestStockInfo)

        //         if (latestStockInfo) {
        //             console.log(" change stock market value ",row.mkt_price,latestStockInfo.LastDone/1000)
        //             row.mkt_price = latestStockInfo.LastDone/1000;
                   
        //         }
        //     }
        // });

      //  console.log("_tableData",_tableData)
// setTableData(JSON.parse(JSON.stringify(_tableData)));
        
    }


    const groupedByCurrency  = (tableData:any) =>{
        return tableData.reduce((acc, item) => {
            if (!acc[item.c_code]) {
                acc[item.c_code] = [];
            }
            acc[item.c_code].push(item);
            return acc;
        }, {});
    }
    


    return (
        <>
            <ReactTable

                headerStyle={{
                    background: 'rgba(210, 209, 209, 1)',
                    color:"black"
                }}
                columns={tblColumns}
                // data={[{
                //     t_name:"test",
                //     mkt_value:1.000
                // }]}
                data={tableData}
                pageSize={currentPageSizeRef.current}
                loading={loading}
                size='small'
                template="portfolio"
                currentPage={tablePagination.currentPage}
                totalRecords={tablePagination.totalRecords}
                pageChange={(cPage: number) => {
                    // showNotiLoader();
                    requestTableData(accounts, cPage ,_inputs);
                }}
                ableChangePageSize={true}
                onPageSizeChanged={(cPageSize: number) => {
                   // alert(cPageSize)
                    currentPageSizeRef.current = cPageSize
                    requestTableData(accounts, 1 ,_inputs,true,cPageSize);
             
                }}
                hasPagination
                CustomFooter={         
                   <>
                        {
                            Object.keys(currencyGroupData).map(currency => {
                                let row = currencyGroupData[currency];
                                let data = calculateFooterCurrencyData(row)


                                return (<>
                                        <tr>
                                            <td colSpan={2} className='p-2'>Total Value({currency})</td> 
                                            <td></td>
                                            <td></td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalQuantity)}
                                                </div>
                                            </td>    
                                            <td></td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalCost,3)}
                                                </div>
                                            </td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalCostMYR,3)}
                                                </div>
                                            </td>
                                            <td></td>
                                            {/* <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(totalAvgPrice,3)}
                                                </div>
                                            </td> */}
                                            <td></td>
                                            <td></td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalMarketValue,3)}
                                                </div>
                                            </td>
                                            <td className='p-2'> 
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalMarketValueMYR,3)}
                                                </div>
                                            </td>
                                            <td className='p-2'>
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalPnl,3)}
                                                </div>
                                            </td>
                                            <td className='p-2'>
                                                <div className="text-right">
                                                    {numberWithCommas(data.totalPnlPerc,3)}
                                                </div>
                                            </td>
                                        </tr>
                                
                                </>)
                            }) 
                        }
                    
                   </>
 
                }
            />
        </>
    );
};

export default PortfolioUnrealizedTbl;
